import { StyleSheet, ViewStyle, TextStyle, ImageStyle } from "react-native"

type CommonProperties<A, B> = {
  [K in Extract<keyof A, keyof B>]: A[K] extends B[K]
    ? B[K] extends A[K]
      ? A[K]
      : never
    : never
} extends infer O
  ? { [K in keyof O as O[K] extends never ? never : K]: O[K] }
  : never

type ImageViewStyle = CommonProperties<ImageStyle, ViewStyle>

type TextViewStyle = Omit<CommonProperties<TextStyle, ViewStyle>, "tabIndex">

export type { ViewStyle, TextStyle, ImageStyle, ImageViewStyle, TextViewStyle }

/**
 * This creates a stylesheet style object. Use this when creating static styles
 * that can't easily be managed by styled-components. This should be called at
 * the module level or, if called from within a component, memoized.
 *
 * Why the helper? Stylesheet.create is a painful API. It is optimized for
 * multiple style objects and is improperly typed. It is helpful for performance
 * on react native though.
 */
export function createStyle<T extends ViewStyle | TextStyle | ImageStyle>(
  style: T,
) {
  return StyleSheet.create({
    style: style as ViewStyle | TextStyle | ImageStyle,
  }).style as T
}
